export const actions = {
  authenticate: ()=>{
    return {
      type: 'AUTHENTICATED'
    }
  },
  unauthenticate: ()=>{
    return {
      type: 'UNAUTHENTICATED'
    }
  },
  logOut: ()=>{
    return {
      type: 'LOGOUT'
    }
  },
  logIn: (email, password, status="requested")=>{
    return{
      type: 'LOGIN',
      payload: {email: email, password: password, status: status}
    }
  },
  register: (email, password, status="requested")=>{
    return{
      type: 'REGISTER',
      payload: {email: email, password: password, status: status}
    }
  },
  online: ()=>{
    return {
      type: 'ONLINE'
    }
  },
  offline: ()=>{
    return{
      type: 'OFFLINE'
    }
  },
  drink: ()=>{
    return{
      type: 'DRINK'
    }
  },
  sync: (amount)=>{
    return{
      type: 'SYNC',
      payload: {amount: amount}
    }
  },
  user: (user, status="normal")=>{
    return{
      type: 'USER',
      payload: {
        user: user,
        status: status
      }
    }
  },
  profile: (displayName, userName)=>{
    return{
      type: 'PROFILE',
      payload: {displayName: displayName,
                userName: userName
              }
    }
  },
  prefs: (prefs)=>{
    return{
      type: 'PREFS',
      payload: prefs
    }
  },
  card: (card, submitted=false)=>{
    return{
      type: 'CARD',
      payload:{card: card, submitted:submitted}
    }
  },
  deleteCard: (req = true)=>{
    return{
      type: 'DELETECARD',
      payload:{deleteCard: req}
    }
  },
  donate: (amount=1, completed=false)=>{
    return{
      type: 'DONATE',
      payload: {
        amount: amount,
        completed: completed
      }
    }
  },
  charges: (charges)=>{
    return{
      type: 'CHARGES',
      payload: charges
    }
  },
  error: (message, status="requested")=>{
    return{
      type: 'ERROR',
      payload: {message:message, status: status}
    }
  },
  fileUpload: (file, status="requested")=>{
    return{
      type: 'UPLOAD',
      payload: {file:file, status: status}
    }
  },
  fileUploadProgress: (progress)=>{
    return{
      type: 'UPLOADPROGRESS',
      payload: {progress: progress}
    }
  },
  stats: (stats)=>{
    return{
      type: 'STATS',
      payload: stats
    }
  }
}



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/actions/actions.js